module.exports = __webpack_public_path__ + "static/media/5_4.34eafac9.png";